import { render, staticRenderFns } from "./LeadXpressFrom.vue?vue&type=template&id=d2f3aa4e&"
import script from "./LeadXpressFrom.vue?vue&type=script&lang=js&"
export * from "./LeadXpressFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports